import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { IconArrowLeft } from '../components/icons';

const FAQ = [
  {
    pergunta: 'Posso denunciar anonimamente?',
    resposta: 'Sim. A denúncia anônima não pede nome, e-mail, telefone nem qualquer dado que identifique você. O sistema também não registra seu IP, localização ou qualquer identificador técnico nesse fluxo.',
  },
  {
    pergunta: 'O WhatsApp é anônimo?',
    resposta: 'O canal de WhatsApp, quando disponível, recebe a mensagem sem vincular seu contato ao relato dentro do sistema de apuração — o mesmo tratamento de sigilo dado às denúncias pelo portal.',
  },
  {
    pergunta: 'Meu gestor saberá que fui eu?',
    resposta: 'Não. A identidade só existe quando você escolhe se identificar, e mesmo assim é cifrada e só pode ser revelada por um número muito restrito de pessoas, em caráter excepcional e sempre com registro de auditoria.',
  },
  {
    pergunta: 'Preciso apresentar provas?',
    resposta: 'Não é obrigatório. Provas e evidências ajudam a apuração a ser mais rápida e precisa, mas o relato por si só já é suficiente para abrir um caso.',
  },
  {
    pergunta: 'Posso acompanhar o caso?',
    resposta: 'Sim. Ao final da denúncia você recebe um protocolo e um PIN — guarde os dois, eles não são mostrados novamente. Com eles você consulta o andamento a qualquer momento em "Acompanhar manifestação".',
  },
  {
    pergunta: 'O que acontece após a denúncia?',
    resposta: 'O caso passa por triagem (classificação e definição de prioridade), pode ser investigado por alguém sem conflito de interesse com os envolvidos, e é encerrado com um resultado registrado. Você pode acompanhar cada mudança de status pelo protocolo.',
  },
  {
    pergunta: 'E se a denúncia for contra RH?',
    resposta: 'Quem trabalha no RH e estiver envolvido no relato é automaticamente impedido de participar do caso. O sistema detecta esse conflito de interesse e afasta a pessoa da apuração.',
  },
  {
    pergunta: 'E se for contra um diretor?',
    resposta: 'Casos envolvendo diretoria, sócios, presidência ou membros do comitê seguem um fluxo especial, encaminhados a uma rota independente (comitê independente, jurídico externo ou investigador externo), fora da cadeia hierárquica normal.',
  },
  {
    pergunta: 'Posso complementar informações?',
    resposta: 'Sim. Na tela de acompanhamento (com protocolo e PIN) existe uma opção para enviar mensagens adicionais ao investigador, mantendo o anonimato.',
  },
  {
    pergunta: 'O que é retaliação?',
    resposta: 'Retaliação é qualquer ação negativa contra quem denunciou de boa-fé — represália, perseguição, prejuízo na carreira. É proibida e tratada como prioridade máxima: uma denúncia de retaliação eleva automaticamente a criticidade do caso.',
  },
  {
    pergunta: 'Posso procurar uma autoridade externa?',
    resposta: 'Sim. Este canal não substitui o direito de recorrer a órgãos públicos, sindicatos ou autoridades externas — é um caminho adicional, não exclusivo.',
  },
  {
    pergunta: 'Quanto tempo leva a análise?',
    resposta: 'Cada categoria de denúncia tem um prazo de referência definido internamente, e o andamento do seu caso pode ser acompanhado pelo protocolo. Casos mais graves têm prioridade e prazos mais curtos.',
  },
];

function Transparencia() {
  const navigate = useNavigate();

  return (
    <div className="container">
      <button className="btn-back" onClick={() => navigate('/')}><IconArrowLeft /> Início</button>

      <div className="step-heading">
        <p className="eyebrow">Ouvir · Proteger · Construir juntos</p>
        <h2>Transparência</h2>
        <p className="info-text">
          Este canal existe para que qualquer pessoa possa relatar o que não está certo,
          com segurança e sem medo. Aqui explicamos como ele funciona.
        </p>
      </div>

      <div className="transparencia-secoes">
        <section className="transparencia-secao">
          <h3>O que é o Canal de Ética</h3>
          <p>
            Um canal para receber denúncias, reclamações, sugestões e elogios relacionados
            à conduta ética do Grupo Vilarouca — assédio, corrupção, fraude, discriminação,
            conflito de interesses e outras condutas contrárias ao nosso código de ética.
          </p>
        </section>

        <section className="transparencia-secao">
          <h3>Quem pode usar</h3>
          <p>
            Colaboradores, ex-colaboradores, clientes, fornecedores, prestadores de serviço,
            parceiros, candidatos a vaga e qualquer pessoa que tenha presenciado ou sofrido
            uma conduta que mereça ser relatada.
          </p>
        </section>

        <section className="transparencia-secao">
          <h3>O que denunciar</h3>
          <p>
            Situações como assédio moral ou sexual, discriminação, corrupção, fraude, desvio
            de recursos, conflito de interesses, violação de política interna, retaliação e
            qualquer conduta que contrarie o código de ética do grupo. Reclamações, sugestões
            e elogios sobre atendimento, processos e lojas também têm espaço próprio.
          </p>
        </section>

        <section className="transparencia-secao">
          <h3>Como funciona o anonimato</h3>
          <p>
            Na denúncia anônima, nenhum dado pessoal é pedido, e o sistema não grava IP,
            localização, cookies ou qualquer identificador de quem denuncia. Protocolo e PIN
            são a única forma de acompanhar o caso depois.
          </p>
        </section>

        <section className="transparencia-secao">
          <h3>Como funciona a confidencialidade</h3>
          <p>
            Todo o conteúdo sensível (descrição, envolvidos, evidências) é cifrado no banco
            de dados. O acesso segue permissões restritas por perfil e, quando aplicável,
            por autorização pontual — cada acesso a um caso fica registrado em log de
            auditoria imutável.
          </p>
        </section>

        <section className="transparencia-secao">
          <h3>O que é retaliação</h3>
          <p>
            É qualquer represália contra quem denunciou de boa-fé: perseguição, punição
            disfarçada, prejuízo na carreira. É expressamente proibida pelo código de ética,
            e uma denúncia de retaliação é tratada com prioridade máxima.
          </p>
        </section>

        <section className="transparencia-secao">
          <h3>Como acompanhar</h3>
          <p>
            Guarde o protocolo e o PIN mostrados ao final do envio — eles não são exibidos
            de novo. Com eles, use <Link to="/acompanhamento">Acompanhar manifestação</Link> para
            ver o status a qualquer momento e enviar mensagens adicionais ao investigador.
          </p>
        </section>

        <section className="transparencia-secao">
          <h3>Perguntas frequentes</h3>
          <div className="faq-lista">
            {FAQ.map((item) => (
              <details key={item.pergunta} className="faq-item">
                <summary>{item.pergunta}</summary>
                <p>{item.resposta}</p>
              </details>
            ))}
          </div>
        </section>

        <section className="transparencia-secao">
          <h3>Política de privacidade e Código de Ética</h3>
          <p>
            Leia a <Link to="/privacidade">Política de Privacidade</Link> para saber
            exatamente quais dados são tratados e por quanto tempo. O Código de Ética
            completo do Grupo Vilarouca está disponível com a área de Compliance/RH.
          </p>
        </section>

        <section className="transparencia-secao">
          <h3>Outros canais</h3>
          <p>
            Além deste portal{process.env.REACT_APP_WHATSAPP_NUMERO ? ' e do WhatsApp' : ''},
            este canal não substitui o direito de recorrer a órgãos públicos, sindicatos
            ou outras autoridades externas competentes.
          </p>
        </section>
      </div>
    </div>
  );
}

export default Transparencia;
